import { Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormEventService } from '@hub/services/form-event.service';
import { IFileUploadDelegate } from '@hub/common/Delegates';

const noop = () => { };

export const CUSTOM_DROPZONE_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FormDropzoneComponent),
  multi: true
};

@Component({
  selector: 'fm-dropzone',
  templateUrl: 'form-dropzone.component.html',
  styleUrls: ['form-dropzone.component.css'],
  providers: [CUSTOM_DROPZONE_CONTROL_VALUE_ACCESSOR]
})
export class FormDropzoneComponent
  implements ControlValueAccessor, OnInit, OnDestroy {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    public formEventService: FormEventService
  ) { }

  @ViewChild('in') public input: ElementRef;
  @Input() public callback: IFileUploadDelegate;
  @Input() disabled: boolean = false;
  @Output() onUpload = new EventEmitter();
  @Input() useOnUpload: boolean;

  public tabindex: string;

  public set tabind(val: string) {
    this.tabindex = String(val);
  }

  public inputType: string;
  private numOfTabs: number = 0;
  private innerValue: any = '';
  // Placeholders for the callbacks which are later provided
  // by the Control Value Accessor
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  ngOnInit() {
    this.formEventService.setIndex(parseInt(this.tabindex));

    const elem: HTMLElement = this.el.nativeElement;

    setTimeout(() => {
      let clickAbleElm = elem.querySelector('.ui-clickable');
      clickAbleElm.textContent = "";
      clickAbleElm.insertAdjacentHTML('beforeend', '<div class="pi pi-upload"></div>');
      clickAbleElm.insertAdjacentHTML('beforeend', '<div>Drag & Drop</div>');
      clickAbleElm.insertAdjacentHTML('beforeend', '<div>your files here, or <span class="drag-drop-title-browse">browse<span></div>');
    }, 10);


    this.renderer.setStyle(elem, 'outline', 'none');
  }

  public ngOnDestroy(): void {
  }

  get value(): any {
    return this.innerValue;
  }

  // set accessor including call the onchange callback
  set value(v: any) {
    if (v !== this.value) {
      this.writeValue(v);
      this.onChangeCallback(v);
    }
  }

  // From ControlValueAccessor interface
  public writeValue(value: any) {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  // From ControlValueAccessor interface
  public registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  // From ControlValueAccessor interface
  public registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  public fileUploadCallback(event) {
    if (event.files.length > 0) {
      let file = event.files[0];
      this.callback(file);
      if (!!this.useOnUpload) {
        this.onUpload.emit();
      }
    } else {
      throw Error('No file uploaded');
    }
  }
}
